// extracted by mini-css-extract-plugin
export var disabled = "_80-5";
export var fileName = "_80-b";
export var filePreview = "_80-4";
export var hoverFilter = "_80-6";
export var imageButton = "_80-3 _80-6";
export var imageButtonContainer = "_80-2";
export var input = "_80-7";
export var removeButton = "_80-0";
export var removeButtonFile = "_80-1";
export var spinner = "_80-9";
export var spinnerContainer = "_80-8";
export var videoContainer = "_80-a _80-6";